import React, { useEffect, useRef, useState } from 'react';
import { EditorState, convertToRaw } from "draft-js";
import 'draft-js/dist/Draft.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import "./AjouterModifierContribution.scss"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    addContributionToServer,
    getContributionById,
    getSousCategoriesRef,
    updateContribution
} from "../../api/contributionsService";
import {
    fromDateInputToDdSlashMmSlashYyyy,
    fromIso8601ToDdSlashMmSlashYyyy,
    fromIso8601ToYyyyDashMmDashDD
} from "../../utils/dateUtils";
import ContentState from "draft-js/lib/ContentState";
import { replaceUrlPlaceholders } from "react-utils";
import ImageWithTextTemplate from "../../Components/TemplatesEditor/ImageWithTextTemplate/ImageWithTextTemplate ";
import ReactDOMServer from "react-dom/server";
import { containsTextOrImage } from "../../utils/htmlUtils";
import LoadingOverlay from "../../Components/LoadingOverlay/LoadingOverlay";
import { getLabelInput } from "../../utils/stringUtils";
import { renderError } from "../../utils/formUtils";
import moment from "moment/moment";

export default function AjouterModifierContribution() {

    // TODO Ajouter des contrôles
    // TODO améliorer le html enrichi pour pouvoir bouger les images bon pas exactement possible
    // TODO gérer les contributions modifié, extraire les images et le texte  etc
    const navigate = useNavigate()
    // const location = useLocation()
    // const pathname = location?.pathname
    //
    // const onContributionPage = pathname?.includes("contribution")

    const {
        id,
    } = useParams()

    const CONF = window?.confPub;
    const ROUTES = CONF?.ROUTES;

    const {
        ID,
        TITLE,
        CATEGORIE,
        SOUS_CATEGORIE,
        AUTRE_SOUS_CATEGORIE,
        DATE,
        DATE_PUBLICATION,
        DATE_FIN_PUBLICATION,
        CORPS,
    } = CONF?.UI?.ADMINISTRATION

    const getIntialContribution = (contributionFromServeur) => {

        const {
            id,
            title,
            categorie,
            sousCategorie,
            date,
            datePublication,
            dateFinPublication,
            corps,
        } = { ...contributionFromServeur }

        return {
            [ID?.NAME]: {
                name: ID?.NAME,
                value: id ?? "",
                invalid: false,
            },
            [TITLE?.NAME]: {
                name: TITLE?.NAME,
                value: title ?? "",
                invalid: title ? false : TITLE?.ERRORS?.MANDATORY,
            },
            [CATEGORIE?.NAME]: {
                name: CATEGORIE?.NAME,
                value: categorie ?? "",
                invalid: categorie ? false : CATEGORIE?.ERRORS?.MANDATORY,
            },
            [SOUS_CATEGORIE?.NAME]: {
                name: SOUS_CATEGORIE?.NAME,
                value: sousCategorie ?? "",
                invalid: sousCategorie ? false : SOUS_CATEGORIE?.ERRORS?.MANDATORY,
            },
            [AUTRE_SOUS_CATEGORIE?.NAME]: {
                name: AUTRE_SOUS_CATEGORIE?.NAME,
                value: "",
                invalid: false,
            },
            [DATE?.NAME]: {
                name: DATE?.NAME,
                value: date ? fromIso8601ToYyyyDashMmDashDD(date) : "",
                invalid: date ? false : DATE?.ERRORS?.MANDATORY,
            },
            [DATE_PUBLICATION?.NAME]: {
                name: DATE_PUBLICATION?.NAME,
                value: datePublication ? fromIso8601ToYyyyDashMmDashDD(datePublication) : "",
                invalid: datePublication ? false : DATE_PUBLICATION?.ERRORS?.MANDATORY,
            },
            [DATE_FIN_PUBLICATION?.NAME]: {
                name: DATE_FIN_PUBLICATION?.NAME,
                value: dateFinPublication ? fromIso8601ToYyyyDashMmDashDD(dateFinPublication) : "",
                invalid: false,
            },
            [CORPS?.NAME]: {
                name: CORPS?.NAME,
                value: corps ?? "",
                invalid: corps ? false : CORPS?.ERRORS?.MANDATORY,
            },
        }
    }

    const [submitted, setSubmitted] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [contribution, setContribution] = useState(getIntialContribution())
    const [templateHtml, setTemplateHtml] = useState('');
    const [sousCategoriesRef, setSousCategoriesRef] = useState([])
    // const [editorState, setEditorState] = useState(
    //     () => EditorState.createEmpty(),
    // );
    const [loaded, setLoaded] = useState(false)

    const cleanInputsRef = useRef(null);
    const setCleanFunction = (childFunction) => {
        cleanInputsRef.current = childFunction;
    };

    useEffect(() => {

        if (id) {
            const fetchContributionById = async () => {

                try {
                    const contributionFromServeur = await getContributionById(id)
                    setContribution(getIntialContribution(contributionFromServeur))

                    setTemplateHtml(JSON.parse(contributionFromServeur?.corps))
                    // setEditorState(htmlToEditorState(JSON.parse(contributionFromServeur?.corps)));
                    setLoaded(true)

                } catch (err) {

                    console.log("err", err)
                } finally {
                    setIsLoading(false)
                }
            }

            fetchContributionById()
        } else {
            setIsLoading(false)
        }

        const fetchSousCategoriesRef = async () => {

            try {
                const { sousCategoriesRef } = await getSousCategoriesRef()

                if (sousCategoriesRef) {

                    setSousCategoriesRef(sousCategoriesRef)
                }

            } catch (err) {
                console.log("err", err)
            }
        }

        fetchSousCategoriesRef()

    }, [])

    const checkAdministrationInput = (name, value, contribution) => {

        let invalid = false

        switch (name) {

            case TITLE?.NAME:
            case CATEGORIE?.NAME:
            case SOUS_CATEGORIE?.NAME:
                if (!value) {

                    invalid = "Obligatoire"
                }

                break

            case AUTRE_SOUS_CATEGORIE?.NAME:

                if (contribution?.[SOUS_CATEGORIE?.NAME]?.value === "Autre" && !value) {

                    invalid = "Obligatoire"
                }
                break

            case DATE?.NAME:
            case DATE_PUBLICATION?.NAME:
                if (!value) {
                    invalid = "Date obligatoire"
                }
            case DATE_FIN_PUBLICATION?.NAME:

                const isValid = moment(value).isValid()

                if (value && !isValid) {

                    invalid = "Date invalide"
                }
                break
        }

        return invalid
    }

    const handleInput = (e) => {

        const { name, value, type } = e?.target

        let invalid = checkAdministrationInput(name, value, contribution)

        setContribution((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState?.[name],
                value: value,
                invalid: invalid
            },
            ...(name === SOUS_CATEGORIE?.NAME && {
                [AUTRE_SOUS_CATEGORIE?.NAME]: {
                    ...prevState?.[AUTRE_SOUS_CATEGORIE?.NAME],
                    invalid: value === "Autre" ? AUTRE_SOUS_CATEGORIE?.ERRORS?.MANDATORY : false
                }
            })

        }));
    }

    const handleCorps = (jsx) => {

        let invalid = false

        if (!containsTextOrImage(jsx)) {
            invalid = CORPS?.ERRORS?.MANDATORY
        }

        setContribution({
            ...contribution,
            [CORPS?.NAME]: {
                ...contribution?.[CORPS?.NAME],
                value: jsx,
                invalid: invalid,
            }
        })
    }

    const checkAndBuildFormData = (contribution) => {

        let invalidForm = false
        const formData = {}

        Object.keys(contribution).forEach(key => {
            const champ = contribution[key];

            const { name, value } = champ

            const champInvalid = checkAdministrationInput(name, value, contribution)

            // AUTRE_SOUS_CATEGORIE s'il est rempli va venir alimenter le champ sous-catégorie pour l'envoi
            if (value && name !== AUTRE_SOUS_CATEGORIE?.NAME) {

                let valueData = value

                if (name === CORPS?.NAME) {

                    valueData = ReactDOMServer.renderToStaticMarkup(contribution?.[name]?.value)
                } else if (name === SOUS_CATEGORIE?.NAME && value === "Autre") {

                    valueData = contribution?.[AUTRE_SOUS_CATEGORIE?.NAME]?.value
                }

                formData[name] = valueData
            }

            invalidForm = champInvalid ? champInvalid : invalidForm
        });

        return { formData, invalidForm }
    }

    const saveContribution = async () => {

        setSubmitted(true)
        setIsLoading(true)

        const { formData, invalidForm } = checkAndBuildFormData(contribution)

        console.log("~~~~~~~~~~~~~~~~~~~~~~")
        console.log("invalidForm")
        console.log(invalidForm)
        console.log("formData")
        console.log(formData)
        console.log("~~~~~~~~~~~~~~~~~~~~~~")


        if (!invalidForm) {

            try {

                const contributionAdded = await addContributionToServer(formData)
                console.log("contributionAdded", contributionAdded)

                if (contributionAdded?.code === 201) {
                    if (cleanInputsRef.current) {
                        cleanInputsRef.current();
                    }

                    setContribution(getIntialContribution())
                    // setEditorState(EditorState.createEmpty())
                    setSubmitted(false)
                }

            } catch (err) {

                console.log("err", err)

            } finally {

                setIsLoading(false)
            }
        } else {
            setIsLoading(false)
        }
    }

    const htmlToEditorState = (html) => {
        const contentBlock = htmlToDraft(html);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        return EditorState.createWithContent(contentState);
    };

    const modifierContribution = async () => {

        console.log("Modification de la publication")

        const { formData, invalidForm } = checkAndBuildFormData(contribution)

        console.log("formData UPDATE")
        console.log(formData)

        if (!invalidForm) {

            try {

                const contributionAdded = await updateContribution(id, formData)
                console.log("contributionAdded", contributionAdded)

                if (contributionAdded?.code === 200) {

                    voirContribution(id)
                }

            } catch (err) {

                console.log("err", err)
            }
        }
    }

    const voirContribution = (id) => {

        const urlVoirContribution = replaceUrlPlaceholders(ROUTES?.PAGES?.CONTRIBUTIONS?.VOIR_CONTRIBUTION,
            { id: id });

        navigate(urlVoirContribution)
    }

    const renderErrorDiv = (message) => {

        return (
            <div className={ "ms-2" }>
                { renderError(message) }
            </div>
        )
    }

    return (
        <div className='container mt-3'>
            <main id='content' className='overlay-container'>

                { isLoading && <LoadingOverlay classes="upload-overlay"/> }

                <div className="card">
                    <div className="card-header">
                        <h1>{ id ? " Modifier la contribution :" : "Ajouter une contribution :" }</h1>
                    </div>

                    <div className="card-body">

                        <form action="">
                            <div className="row mt-4">
                                <div className="col-lg-8 d-flex align-items-center no-wrap">
                                    <label
                                        htmlFor={ TITLE?.NAME }
                                        className="form-label label-inline">
                                        { getLabelInput(TITLE) }
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={ TITLE?.NAME }
                                        id={ TITLE?.NAME }
                                        onChange={ handleInput }
                                        value={ contribution?.[TITLE?.NAME]?.value }
                                        placeholder={ TITLE?.NAME?.PLACEHOLDER }/>

                                    { submitted && contribution?.[TITLE?.NAME]?.invalid
                                        && renderErrorDiv(contribution?.[TITLE?.NAME]?.invalid) }
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-auto d-flex align-items-center no-wrap ml-4 mt-3">
                                    <label className="form-label label-inline">
                                        { getLabelInput(CATEGORIE) }
                                    </label>

                                    { CATEGORIE?.OPTIONS?.length > 0 && CATEGORIE?.OPTIONS?.map(option => (
                                        <div className="form-check form-check-inline"
                                             key={ option?.ID }
                                        >
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={ CATEGORIE?.NAME }
                                                id={ option?.ID }
                                                value={ option?.VALUE }
                                                checked={ contribution?.[CATEGORIE?.NAME]?.value === option?.VALUE }
                                                onChange={ handleInput }
                                            />
                                            <label className="form-check-label" htmlFor={ option?.ID }>
                                                { option?.VALUE }
                                            </label>
                                        </div>
                                    )) }

                                    { submitted && contribution?.[CATEGORIE?.NAME]?.invalid
                                        && renderErrorDiv(contribution?.[CATEGORIE?.NAME]?.invalid) }
                                </div>

                                <div className="col-auto form-group d-flex align-items-center no-wrap mt-3">
                                    <label
                                        htmlFor={ SOUS_CATEGORIE?.NAME }
                                        className="form-label label-inline">
                                        { getLabelInput(SOUS_CATEGORIE) }
                                    </label>
                                    <select
                                        id={ SOUS_CATEGORIE?.NAME }
                                        name={ SOUS_CATEGORIE?.NAME }
                                        className="form-control"
                                        value={ contribution?.[SOUS_CATEGORIE?.NAME]?.value }
                                        onChange={ handleInput }
                                    >
                                        <option value="" disabled>Sélectionner</option>
                                        { sousCategoriesRef?.length > 0 && sousCategoriesRef?.map(sousCategorie => (
                                            // eslint-disable-next-line react/jsx-key
                                            <option key={ sousCategorie }
                                                    value={ sousCategorie }>{ sousCategorie }</option>
                                        ))}

                                        { SOUS_CATEGORIE?.OPTIONS?.length > 0 && SOUS_CATEGORIE?.OPTIONS?.map(option => (
                                            // eslint-disable-next-line react/jsx-key
                                            <option key={ option?.ID }
                                                    value={ option?.VALUE }>{ option?.VALUE }</option>
                                        ))}
                                    </select>


                                    { submitted && contribution?.[SOUS_CATEGORIE?.NAME]?.invalid
                                        && renderErrorDiv(contribution?.[SOUS_CATEGORIE?.NAME]?.invalid) }

                                </div>

                                { contribution?.[SOUS_CATEGORIE?.NAME]?.value === 'Autre' && (
                                    <div className="form-group col-auto d-flex align-items-center no-wrap mt-3">
                                        <label htmlFor={ AUTRE_SOUS_CATEGORIE?.NAME }
                                               className="form-label label-inline">
                                            { getLabelInput(AUTRE_SOUS_CATEGORIE) }
                                        </label>
                                        <input
                                            id={ AUTRE_SOUS_CATEGORIE?.NAME }
                                            name={ AUTRE_SOUS_CATEGORIE?.NAME }
                                            className="form-control"
                                            type="text"
                                            value={ contribution?.[AUTRE_SOUS_CATEGORIE?.NAME]?.value }
                                            onChange={ handleInput }
                                        />

                                        { submitted && contribution?.[AUTRE_SOUS_CATEGORIE?.NAME]?.invalid
                                            && renderErrorDiv(contribution?.[AUTRE_SOUS_CATEGORIE?.NAME]?.invalid) }
                                    </div>
                                ) }
                            </div>

                            <div className='row'>
                                <div className="col-auto d-flex align-items-center no-wrap mt-3">
                                    <label
                                        htmlFor={ DATE?.NAME }
                                        className="form-label label-inline">
                                        { getLabelInput(DATE) }
                                    </label>
                                    <input
                                        id={ DATE?.NAME }
                                        name={ DATE?.NAME }
                                        className="form-control"
                                        type="date"
                                        value={ contribution?.[DATE?.NAME]?.value }
                                        onChange={ handleInput }/>

                                    { submitted && contribution?.[DATE?.NAME]?.invalid
                                        && renderErrorDiv(contribution?.[DATE?.NAME]?.invalid) }
                                </div>

                                <div className="col-auto d-flex align-items-center no-wrap mt-3">
                                    <label
                                        htmlFor={ DATE_PUBLICATION?.NAME }
                                        className="form-label label-inline">
                                        { getLabelInput(DATE_PUBLICATION) }
                                    </label>
                                    <input
                                        id={ DATE_PUBLICATION?.NAME }
                                        name={ DATE_PUBLICATION?.NAME }
                                        className="form-control"
                                        type="date"
                                        value={ contribution?.[DATE_PUBLICATION?.NAME]?.value }
                                        onChange={ handleInput }/>

                                    { submitted && contribution?.[DATE_PUBLICATION?.NAME]?.invalid
                                        && renderErrorDiv(contribution?.[DATE_PUBLICATION?.NAME]?.invalid) }
                                </div>

                                <div className="col-auto d-flex align-items-center no-wrap mt-3">
                                    <label
                                        htmlFor={ DATE_FIN_PUBLICATION?.NAME }
                                        className="form-label label-inline">
                                        { getLabelInput(DATE_FIN_PUBLICATION) }
                                    </label>
                                    <input
                                        id={ DATE_FIN_PUBLICATION?.NAME }
                                        name={ DATE_FIN_PUBLICATION?.NAME }
                                        className="form-control"
                                        type="date"
                                        value={ contribution?.[DATE_FIN_PUBLICATION?.NAME]?.value }
                                        onChange={ handleInput }/>

                                    { submitted && contribution?.[DATE_FIN_PUBLICATION?.NAME]?.invalid
                                        && renderErrorDiv(contribution?.[DATE_FIN_PUBLICATION?.NAME]?.invalid) }
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-12">
                                    <ImageWithTextTemplate
                                        key={ loaded }
                                        initialHtml={ templateHtml }
                                        onChange={ (html) => setTemplateHtml(html) }
                                        setJsxContent={ handleCorps }
                                        triggerCleanFunction={ setCleanFunction }
                                    />

                                    { submitted && contribution?.[CORPS?.NAME]?.invalid
                                        && renderError(contribution?.[CORPS?.NAME]?.invalid) }
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="row">
                        <div className='col-12'>
                            {/* TODO cahnger l'affichage pour message*/ }
                            <h2 className="ms-3">Prévisualisation :</h2>

                            <div className="preview-class">

                                <h3>{ contribution?.[TITLE?.NAME]?.value }</h3>

                                <div>
                                    <small>
                                        { contribution?.[DATE?.NAME]?.value && (`publié le : ${ fromDateInputToDdSlashMmSlashYyyy(contribution?.[DATE?.NAME]?.value) }`) }
                                        { contribution?.[CATEGORIE?.NAME]?.value && ` | ${ contribution?.[CATEGORIE?.NAME]?.value }` }
                                        { contribution?.[SOUS_CATEGORIE?.NAME]?.value && ` | ${ contribution?.[SOUS_CATEGORIE?.NAME]?.value }` }
                                        <span className='grey-text'>
                                { contribution?.[DATE_PUBLICATION?.NAME]?.value && ` | date de publication : ${ fromDateInputToDdSlashMmSlashYyyy(contribution?.[DATE_PUBLICATION?.NAME]?.value) }` }
                                            { contribution?.[DATE_PUBLICATION?.NAME]?.value
                                                && ` | date de fin de publication : ${ fromDateInputToDdSlashMmSlashYyyy(contribution?.[DATE_PUBLICATION?.NAME]?.value ) }` }
                                  </span>
                                    </small>
                                </div>

                                <div
                                    className="mt-3">
                                    { contribution?.[CORPS?.NAME]?.value }
                                </div>

                                <div>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row m-3">
                        { id && (
                            <div className="col-4">
                                <button
                                    className="btn btn-outline-primary" type='button'
                                    onClick={ () => voirContribution(id) }>
                                    Retourner sur la contribution
                                </button>
                            </div>
                        ) }
                        <div className="col-4">
                            <button
                                className="btn btn-primary" type='button'
                                onClick={ id ? () => modifierContribution(id) : saveContribution }>
                                { id ? "Modifier la contribution" : "Enregistrer la contribution" }
                            </button>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    )
}